export const CHIPS = ['Professional', 'Great Communication', 'Handled Product Carefully', 'Took Pride in their work'];
